import { rest } from 'msw';
import { RequestBody, Responses } from './interfaces';
import { carriers } from '../fixtures/carriers';
import { importResult } from '../fixtures/importResult';
import { templates } from '../fixtures/templates';
import { tiendaNubeToken } from '../fixtures/tiendaNubeToken';
import { delayedResponse } from '../responses/delayedResponse';

export enum ChameleonAjaxEndpoints {
    GET_ORDER_TEMPLATES = 'getOrderTemplates',
    SAVE_ORDER_TEMPLATES = 'saveOrderTemplates',
    GET_TIENDANUBE_TOKEN = 'getTiendaNubeToken',
    IMPORT_TIENDANUBE = 'getTiendaNubeOrders',
    GET_TIENDANUBE_CARRIERS = 'getTiendaNubeCustomCarriers',
    DELETE_TEMPLATE = 'deleteTemplate',
    GET_INTEGRATIONS = 'getIntegrations',
}

const responses: Responses = {
    getOrderTemplates: () => ({ status: 200, json: templates }),
    saveOrderTemplates: ({ json_order_template }) => {
        const templateId = JSON.parse(json_order_template || '')?.id;
        const template = templates.find((template) => template.id === templateId) || templates[0];

        return { status: 201, json: { ...template } };
    },
    getTiendaNubeToken: () => ({ status: 200, json: tiendaNubeToken }),
    getTiendaNubeOrders: () => ({ status: 200, json: importResult }),
    getTiendaNubeCustomCarriers: () => ({ status: 200, json: carriers }),
    deleteTemplate: () => ({ status: 200, json: true }),
};
const exceptionResponses: Responses = {
    getOrderTemplates: () => ({ status: 401, json: [] }),
    saveOrderTemplates: () => ({ status: 401, json: false }),
    getTiendaNubeToken: () => ({ status: 200, json: false }),
    getTiendaNubeOrders: () => ({ status: 200, json: false }),
    getTiendaNubeCustomCarriers: () => ({ status: 401, json: [] }),
    deleteTemplate: () => ({ status: 200, json: false }),
};

const postHandler = (responses: Responses) => {
    return rest.post(/\/chameleon_ajax.php$/, async (req, res, ctx) => {
        const { data } = req.body as { data: string };

        const handler = responses[data](req.body as RequestBody);

        if (handler) {
            return delayedResponse(ctx.status(handler.status), ctx.json(handler.json || ''));
        }

        return res(ctx.status(404));
    });
};

export const chameleonAjaxHandlers = [postHandler(responses)];

export const chameleonAjaxHandlersWithExceptions = (methods: Array<ChameleonAjaxEndpoints>) => {
    const selectedExceptions = methods
        .filter((method) => exceptionResponses[method.toString()])
        .reduce((obj: Responses, method) => {
            obj[method.toString()] = exceptionResponses[method.toString()];
            return obj;
        }, {});

    return [postHandler({ ...responses, ...selectedExceptions })];
};
